import React, { useEffect, useState } from 'react';

const AnimatedDots = () => {
  const [dots, setDots] = useState('...');

  useEffect(() => {
    const timer = setInterval(() => {
      setDots((prev) => {
        if (prev === '..') return '...';
        if (prev === '.') return '..';
        if (prev === '') return '.';
        return '';
      });
    }, 500);

    return () => clearInterval(timer);
  }, []);

  return <span>{dots}</span>;
};

export default AnimatedDots;
